import Vue from 'vue'

module.export = Vue.component('exportmailsettingsmodal',
    {
        name: 'exportmailsettings',
        props: {
            data: Object
        },
        components: {},
        data: function () {
            return {
                alerts: [],
                exportMailSettingSelection: 'exportDefaultMailSettings'
            };
        },
        methods: {
            addAlert: function (event) {
                this.alerts = [];
                this.alerts.push(event);
            },
            clearAlert: function (index) {
                this.alerts.splice(index, 1);
            },
            save: function (e) {
                e.preventDefault();
                const _this = this;
                _this.clearAlert();

                this.$validator.validateAll().then((isValid) => {
                    if (isValid) {
                        if (_this.exportMailSettingSelection == "exportDefaultMailSettings") {
                            var grid = _this.$parent.$refs.grid.kendoWidget();
                            grid.setOptions({
                                excel: {
                                    allPages: true
                                }
                            });
                            grid.saveAsExcel();
                        }
                        if (_this.exportMailSettingSelection == "exportCompanyMailSettingsOverrides") {
                            $.ajax({
                                type: 'GET',
                                url: '/Settings/ManageMailSettings/GetCompanyMailSettingOverrides',
                                success: function (data) {
                                    var workbook = new kendo.ooxml.Workbook({
                                        sheets: [
                                            {
                                                rows: [
                                                    {
                                                        cells: [
                                                            { value: "Company name" },
                                                            { value: "Company location country" },
                                                            { value: "Request new lease email" },
                                                            { value: "Message us email" },
                                                            { value: "Asset request - Termination request email" },
                                                            { value: "Asset request - Return request email" },
                                                            { value: "Asset request - Extension request email" },
                                                            { value: "Asset request - Buy Out request email" }
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    });

                                    for (var i = 0; i < data.length; i++) {
                                        workbook.options.sheets[0].rows.push({
                                            cells: [
                                                { value: data[i].companyName },
                                                { value: data[i].companyLocationCountry },
                                                { value: data[i].requestNewLeaseEmail },
                                                { value: data[i].messageUsEmail },
                                                { value: data[i].terminationRequestEmail },
                                                { value: data[i].returnRequestEmail },
                                                { value: data[i].extensionRequestEmail },
                                                { value: data[i].buyOutRequestEmail }
                                            ]
                                        })
                                    }

                                    workbook.toDataURLAsync().then(function (dataURL) {
                                        kendo.saveAs({
                                            dataURI: dataURL,
                                            fileName: "Export.xlsx"
                                        });
                                    });
                                },
                                error: function (error) {
                                    console.error(error);
                                },
                                contentType: "application/json",
                                dataType: 'json'
                            });
                        }

                        _this.close();
                    } else {
                        _this.addAlert(
                            {
                                "message": 'Could not export mail settings due to incorrect or incomplete fields.',
                                "isSuccess": false
                            });
                    }
                });
                
            },
            escapeClose: function (e) {
                if (e.keyCode == 27) {
                    this.close();
                }
            },
            show: function () {
                $('#emailoverview-export-email-settings').modal('show');
            },
            close: function () {
                this.clearAlert();
                $('#emailoverview-export-email-settings').modal('hide');
            }
        }
    }
);
